import CryptoJS from 'crypto-js'

import {jwtDecode} from "jwt-decode";
import { NativeModules, Platform } from "react-native";
var Aes = NativeModules.Aes;
import {Buffer} from 'buffer'


export const Encryption = async (plaintxt, init_key) => {
  const iv = new Buffer([
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0,
    0x0
  ]);
  const key = CryptoJS.enc.Base64.parse(init_key);
  const iv2 = CryptoJS.enc.Utf8.parse(iv);
  const cipherData = CryptoJS.AES.encrypt(plaintxt+"", key, {
    iv: iv2,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return cipherData.ciphertext.toString(CryptoJS.enc.Base64);
}
export const encryptCaptcha = async (plaintxt) => {
  let asciiKey = "Yq3t6w9z$C&F)J@NcRfUjWnZr4u7x!A%";
  let acsiiIV = "4?_!QWQrC6?Mh*-y";
  
  const iv2 = CryptoJS.enc.Utf8.parse(acsiiIV);
  const key = CryptoJS.enc.Utf8.parse(asciiKey);

  const cipherData = CryptoJS.AES.encrypt(plaintxt+"", key, {
    iv: iv2,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return cipherData.ciphertext.toString(CryptoJS.enc.Base64);

};


export const decryptCaptcha = async (plaintxt) => {

  let asciiKey = "Yq3t6w9z$C&F)J@NcRfUjWnZr4u7x!A%";

  let acsiiIV = "4?_!QWQrC6?Mh*-y";

  const key = CryptoJS.enc.Utf8.parse(asciiKey);

  const iv2 = CryptoJS.enc.Utf8.parse(acsiiIV);

  const cipherData = await CryptoJS.AES.decrypt(plaintxt, key, {

    iv: iv2,

    mode: CryptoJS.mode.CBC,

    padding: CryptoJS.pad.Pkcs7

  });

  let final = await JSON.parse(

    cipherData.toString(CryptoJS.enc.Utf8).replaceAll("\u0000", "")

  );
  console.log(final,"final")
  return final;

};

export const decrypt = (obj) => {
  const data = jwtDecode(obj)
  console.log(data)
  return data
}

export const encrypt_mobile = (plaintxt, encKey) => {
  return new Promise((resolve, reject) => {
    console.log(base64ToHex(encKey));
    Aes.encrypt(plaintxt, base64ToHex(encKey), null)
      .then(cipher => {
        console.log(cipher);
        resolve(cipher);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const decrypt_mobile = cipher => {
  return new Promise((resolve, reject) => {
    Aes.decrypt(cipher, secretKey, null)
      .then(plaintxt => {
        resolve(plaintxt);
      })
      .catch(err => {
        reject(err);
      });
  });
};
const base64ToHex = str => {
  const raw = atobl(str);
  let result = "";
  for (let i = 0; i < raw.length; i++) {
    const hex = raw.charCodeAt(i).toString(16);
    result += hex.length === 2 ? hex : "0" + hex;
  }
  return result.toUpperCase();
};

const atobl = input => {
  var keyStr =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var output = "";
  var chr1, chr2, chr3;
  var enc1, enc2, enc3, enc4;
  var i = 0;
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  do {
    enc1 = keyStr.indexOf(input.charAt(i++));
    enc2 = keyStr.indexOf(input.charAt(i++));
    enc3 = keyStr.indexOf(input.charAt(i++));
    enc4 = keyStr.indexOf(input.charAt(i++));
    chr1 = (enc1 << 2) | (enc2 >> 4);
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    chr3 = ((enc3 & 3) << 6) | enc4;
    output = output + String.fromCharCode(chr1);
    if (enc3 !== 64) {
      output = output + String.fromCharCode(chr2);
    }
    if (enc4 !== 64) {
      output = output + String.fromCharCode(chr3);
    }
  } while (i < input.length);
  return output;
};